const announcement =[
    {
        path: '/search', //公示公告搜索主页
        name: 'search',
        component: () => import('../views/Announcement/search.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/announcementDetails',
        name: 'announcementDetails',
        component: () => import('../views/Announcement/announcementDetails.vue'),
        meta: {
            requiresAuth: true
        }
    },

]
export default announcement
